class LocalStorageKeys {
  static gymToken = "asfhjkjrryioiojmxntnjnjmkmmkt-ioyrfiyity";
}
export default LocalStorageKeys;
